import StyleButton, { StyleButtonContent } from './style';
export default ({children, ...props}) => {
    return (
        <StyleButton {...props}>
            <StyleButtonContent role="button">
                {children}
            </StyleButtonContent>
        </StyleButton>
    )
}